import { render, staticRenderFns } from "./price-group-list.vue?vue&type=template&id=1e549e99"
import script from "./price-group-list.vue?vue&type=script&lang=js"
export * from "./price-group-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports